export default __webpack_public_path__ + "static/stJosephsChurch-5a92b20e43e6044c12c145f42588c27c.svg";